<template>
    <div v-if="isUserText" v-html="text"></div>
    <div v-else>
        <VMarkdownView
            :content="text"
        ></VMarkdownView>
    </div>
</template>
<script>
import { VMarkdownView } from 'vue3-markdown'
export default {
  name: 'MessageContent',
  components: {
    VMarkdownView,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    isUserText: {
      type: Boolean,
    },
  },
};
</script>
